function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState, useCallback } from 'react';
import Draggerjs from 'draggerjs';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import Icon from '../Icon';
import PreventDragButton from '../PreventDragButton';
import ReactDOM from 'react-dom';
import browserAgent from '../../common/utils/browserAgent';
import Button from '../Button';
let cacheCurrentPosition;

const HelpTextModal = ({
  as: Component = Button,
  removeModalTrapFocus,
  modalClassName,
  permissionToEdit,
  className,
  modalBody,
  children,
  ...props
}) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (show) {
      const dragger = new Draggerjs(document.body, {
        allowPointerEvent: !browserAgent.mobile,
        draggable: '.help-text-modal',
        allowWindowBound: true
      }); // fixed the glitch in cursor. in (edge) at the moment there is no solution except this extra call prior to this glitch

      const glitchFixer = browserAgent.edge ? new Draggerjs(document.body) : null;
      dragger.on('dragstart', event => {
        if (event.isDraggableElement) {
          let target = event.target;
          event.preventDefault();
          target.classList.add('is-grabbed');
        }
      });
      dragger.on('dragend', event => {
        if (event.isDraggableElement) {
          let target = event.target;
          target.classList.remove('is-grabbed');
          cacheCurrentPosition = {
            top: event.endY,
            left: event.endX
          };
        }
      });

      const handleEsc = event => {
        if (event.which === 27) {
          setShow(false);
        }
      };

      document.addEventListener('keydown', handleEsc);

      if (removeModalTrapFocus && permissionToEdit) {
        document.querySelector('.modal.show')?.removeAttribute('tabindex');
      }

      return () => {
        document.removeEventListener('keydown', handleEsc);
        dragger.destroy();
        glitchFixer?.destroy();

        if (removeModalTrapFocus && permissionToEdit) {
          document.querySelector('.modal.show')?.setAttribute('tabindex', '-1');
        }
      };
    }
  }, [show]);
  const handleToggle = useCallback(() => {
    setShow(prev => !prev);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({
    type: "button",
    variant: "default"
  }, props, {
    className: classNames("help-text-trigger", null, className),
    onClick: handleToggle
  }), children || /*#__PURE__*/React.createElement(Icon, {
    name: "question"
  })), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(CSSTransition, {
    in: show,
    timeout: 300,
    classNames: "help-text",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    role: "dialog",
    "aria-modal": "true",
    tabIndex: -1,
    className: classNames("help-text-modal", null, modalClassName),
    style: cacheCurrentPosition
  }, /*#__PURE__*/React.createElement("div", {
    className: "help-text-action"
  }, /*#__PURE__*/React.createElement(PreventDragButton, {
    as: "button",
    type: "button",
    className: "help-text-close",
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "times"
  }))), modalBody)), document.body));
};

export default HelpTextModal;